import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/settlements/admin`,
});

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// Ellaa call-kum same error shape → { success:false, error }
async function call(fn) {
  try {
    const res = await fn();
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

export const getSettlementOverview = () =>
  call(() => API.get("/overview", { headers: authHeaders() }));

export const getDriverBalances = (params) =>
  call(() => API.get("/drivers", { params, headers: authHeaders() }));

export const listSettlements = (params) =>
  call(() => API.get("/list", { params, headers: authHeaders() }));

export const getSettlementDetail = (id) =>
  call(() => API.get(`/${id}`, { headers: authHeaders() }));

export const updateSettlementStatus = (id, payload) =>
  call(() => API.patch(`/${id}/status`, payload, { headers: authHeaders() }));

export const generateSettlements = (weekStart) =>
  call(() => API.post("/generate", { weekStart }, { headers: authHeaders() }));

export const getGstReport = (from, to) =>
  call(() =>
    API.get("/gst-report", { params: { from, to }, headers: authHeaders() }),
  );

// CSV download (bank bulk transfer sheet)
export async function downloadSettlementsCsv(params) {
  try {
    const res = await API.get("/export", {
      params,
      headers: authHeaders(),
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(
      new Blob([res.data], { type: "text/csv" }),
    );
    const a = document.createElement("a");
    a.href = url;
    a.download = `driver-settlements${params?.weekStart ? `-${params.weekStart}` : ""}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    return { success: true };
  } catch (err) {
    return { success: false, error: err.response?.statusText || err.message };
  }
}
